export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlNIB', function (NIBApi, $q, $scope) {

    let ctrl = $scope.$parent.ctrl;

    const isWeekend = date => date.getDay() == 6 || date.getDay() == 0;

    ctrl.debitDateDisabled = (date, mode) =>
      mode === 'day' && (_.includes(ctrl.excluded_debit_days, date.getDate()) || isWeekend(date));

    this.joinMinDate = new Date();
    this.joinMaxDate = new Date();
    this.joinMaxDate.setDate(this.joinMaxDate.getDate() + 60);

    $scope.$watch('nibctrl.debit_date', () => {
      if (typeof $scope.nibctrl.debit_date === 'object') {
        ctrl.application.payment.debit_date = this.debit_date;
      }
    });

    const {CREDIT_CARD} = ctrl.fieldsets.payment.type.constants;
    ctrl.preSubmitFunctions.push(application => {
      const {payment} = application;
      const deferred = $q.defer();

      if (payment.type === CREDIT_CARD) {
        NIBApi.encryptCCNumber(payment.credit_card.number).then(
          encryptedCC => {
            deferred.resolve(application => {
              _.set(application, 'payment.credit_card.number', '');
              _.set(application, 'payment.credit_card.encrypted_number', encryptedCC);
              return application;
            });
          }
        ).catch(
          error => deferred.reject({
            payment: {
              credit_card: {
                number: [(error.data && error.data.message) || 'Error tokenizing credit card' ],
              },
            },
          })
        );
        return deferred.promise;
      }

      // Unless it's credit card we we don't need to do anything else so we can resolve straight away
      deferred.resolve();
    });

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-nib.js